import React from 'react';
import c from 'classnames';
import CommentDataAttrDiv from '../../../../lego/CommentDataAttrDiv';
import s from './RootLayout.scss';

interface Props {
  prefix: React.ReactNode;
  contentBlocks: React.ReactNode[];
  className?: string;
}

const RootLayout: React.FC<Props> = ({ className, contentBlocks, prefix, ...rest }) => (
  <CommentDataAttrDiv className={c(s['root'], className)} {...rest}>
    {prefix}
    <div className={s['content']}>{contentBlocks}</div>
  </CommentDataAttrDiv>
);
RootLayout.displayName = 'RootLayout';

export default RootLayout;
